// Marketing copy for the public /partners page (the B2B landing page).
// Distinct from constants/partner.ts, which holds the private portal config.
export const PARTNERS_PAGE = {
  benefits: {
    title: "A partner programme built around privacy",
    subtitle:
      'Everything your organisation needs to offer its people confidential <a href="/services">therapy and counselling services</a>, without the admin overhead or the awkward visibility.',
    items: [
      {
        icon: "lock",
        title: "Private by design",
        body: "Your people book under a pseudonym. Invoices reference a code, never a name, so reaching out for support stays completely confidential.",
      },
      {
        icon: "receipt",
        title: "Simple, per-session billing",
        body: "No seat licences and no upfront cost. Sessions are invoiced to your organisation only as they are used.",
      },
      {
        icon: "services",
        title: "Curated services",
        body: "Choose exactly which therapy and counselling services your organisation offers from our full catalogue.",
      },
      {
        icon: "bolt",
        title: "Fast to set up",
        body: "We create your organisation and your people. They sign in with a one-time code, no passwords to manage.",
      },
    ],
  },
  audience: {
    title: "Made for teams that care about their people",
    body: "Companies investing in employee wellbeing, NGOs supporting their communities, universities, and clinics extending their reach. If you want to offer real mental health support, we make it simple.",
  },
  faqs: {
    title: "Common questions",
    items: [
      {
        question: "How does billing work?",
        answer:
          "There are no seat licences and no upfront cost. Your organisation is invoiced only for sessions your people actually book, at the price we agree with you. You receive a per-session invoice by email as sessions are completed.",
      },
      {
        question: "Will we see who booked a session?",
        answer:
          "No, not when anonymity is enabled for your organisation. Your people book under a pseudonym, and every invoice references that code rather than a name. You can see that sessions were used and what they cost, but never who attended.",
      },
      {
        question: "How do our people sign in?",
        answer:
          "There are no passwords. Each person signs in to the partner portal with a one-time code sent to their work email. You give us the list of people to include, and we set up their access.",
      },
      {
        question: "Which services can our people book?",
        answer:
          "You choose which therapy and counselling services from our catalogue your organisation offers, and at what agreed price. Your people can only book the services you have enabled.",
      },
      {
        question: "How do we get started?",
        answer:
          "Talk to us and we will set up your organisation, add your people, and enable your chosen services. Most partners are up and running the same week.",
      },
    ],
  },
  cta: {
    title: "Ready to support your team?",
    subtitle:
      "Talk to us about bringing Mindful Lume to your organisation, or sign in to your partner portal.",
    contactLabel: "Talk to us",
    contactHref: "/contact",
    loginLabel: "Partner login",
    loginHref: "/partner/login",
  },
} as const;
